export default function HeaderTransparentNav() {
  const header = document.querySelector<HTMLElement>("header");
  const sectionOffset = document.querySelector<HTMLElement>(".add-transparent-header-padding");

  if (!header || !sectionOffset) return;
  const isWhiteColorMode = header.getAttribute("data-colormode") === "White";
  const isTransparentHeader = header.getAttribute("data-istransparent") === "True";

  const mediaQuery = window.matchMedia("(min-width: 993px)");

  const handleTransparentHeader = () => {
    if (window.scrollY === 0) {
      header.setAttribute("data-istransparent", "True");

      if (isWhiteColorMode) {
        header.setAttribute("data-colormode", "White");
      }
    } else {
      header.setAttribute("data-istransparent", "False");

      if (isWhiteColorMode) {
        header.setAttribute("data-colormode", "Black");
      }
    }
  };

  const getNavigationHeight = () => {
    const headerChrome = header.querySelector<HTMLElement>(".js-header-chrome");
    return headerChrome?.offsetHeight ?? header.offsetHeight;
  };

  const handleUpdateSectionOffset = () => {
    // wait for layout to settle after resize
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        const navigationHeight = getNavigationHeight();

        if (isTransparentHeader && mediaQuery.matches) {
          sectionOffset.style.paddingTop = `${navigationHeight}px`;
          sectionOffset.style.marginTop = `-${navigationHeight}px`;
        } else {
          sectionOffset.style.paddingTop = "";
          sectionOffset.style.marginTop = "";
        }
      });
    });
  };

  const handleBannerClose = () => {
    handleUpdateSectionOffset();
  };

  const handleBannerListeners = () => {
    const closeButtons = header.querySelectorAll<HTMLButtonElement>("[data-banner=true][data-open=true] .js-close-btn");

    closeButtons.forEach((btn) => {
      btn.removeEventListener("click", handleBannerClose);
      btn.addEventListener("click", handleBannerClose);
    });
  };

  let resizeTimeout: number;

  const handleResize = () => {
    clearTimeout(resizeTimeout);

    resizeTimeout = window.setTimeout(() => {
      handleUpdateSectionOffset();
    }, 100);
  };

  if (isTransparentHeader) {
    handleTransparentHeader();
    window.addEventListener("scroll", handleTransparentHeader);
  }

  handleUpdateSectionOffset();
  handleBannerListeners();
  window.addEventListener("resize", handleResize);
}
